// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breakLine-wrapper--fba7e8cd{text-align:center}.breakLine-wrapper--fba7e8cd i{font-style:normal}`, "",{"version":3,"sources":["webpack://./src/common/classes/editorjs/BreakLineTool.module.scss"],"names":[],"mappings":"AAAA,6BACE,iBAAA,CAEA,+BACE,iBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakLine-wrapper": `breakLine-wrapper--fba7e8cd`,
	"breakLineWrapper": `breakLine-wrapper--fba7e8cd`
};
export default ___CSS_LOADER_EXPORT___;
